export default [
	{
		path: '/:subDomain/:venueChainId',
		name: 'main',
		component: () => import('../../viewsTicketing/MainTicketing.vue'),
		children: [
			{
				path: 'events',
				name: 'events',
				component: () => import('../../viewsTicketing/Events/Events.vue')
			},
			{
				path: 'events/:eventId',
				name: 'event-details',
				component: () => import('../../viewsTicketing/Events/EventDetails.vue')
			},
			{
				path: 'order/:orderId',
				name: 'order',
				component: () => import('../../viewsTicketing/Order.vue')
			},
			{
				path: 'qr/:ticketId',
				name: 'ticketing-qr',
				component: () => import('../../viewsTicketing/TicketingQR.vue')
			}
		]
	},
	{
		path: '/404',
		name: 'notFound',
		component: () => import('../../viewsTicketing/NotFound.vue')
	},
	{
		path: '*',
		redirect: '404'
	}
]
